import { FunctionComponent } from 'react'
import useViewOrAttachFilesModal from './ViewOrAttachFilesModal.hook'
import {
  Attachments,
  MIME_TYPES,
  Modal,
  Uploader,
} from '@conexasaude/conexa-hero'
import useStyles from './ViewOrAttachFilesModal.styles'

type AttendanceIdType = {
  attendanceSelectedAppointment: number
}

const ViewOrAttachFiles: FunctionComponent<AttendanceIdType> = ({
  attendanceSelectedAppointment,
}) => {
  const {
    modalOpen,
    closeModal,
    attachmentList,
    handleRemoveFile,
    handleUploadAttachment,
    attachmentListIsLoading,
  } = useViewOrAttachFilesModal({ attendanceSelectedAppointment })
  const styles = useStyles()

  return (
    <Modal
      title="Visualizar ou anexar arquivos"
      opened={Boolean(modalOpen)}
      primaryActionLabel="Fechar"
      primaryAction={closeModal}
      negativeAction={closeModal}
      onClose={closeModal}
      size={600}
    >
      <div css={styles.uploaderContainer}>
        <Uploader
          buttonLabel="Selecionar arquivos"
          caption="Arquivos suportados: Documento (.xlsx, .xls e .pdf)."
          onDrop={handleUploadAttachment}
          accept={[MIME_TYPES.xls, MIME_TYPES.xlsx, MIME_TYPES.pdf]}
        />
      </div>
      <div css={styles.attachments}>
        {attachmentList?.map(archive => (
          <Attachments
            key={archive?.attachmentId}
            fileName={archive?.description || ''}
            fileSize={archive?.size || ''}
            variant={attachmentListIsLoading ? 'primary' : 'done'}
            iconFile="xlsx"
            handleRemoveFile={() => handleRemoveFile(archive?.attachmentId)}
          />
        ))}
      </div>
    </Modal>
  )
}

export default ViewOrAttachFiles
